import cx from "classnames";
import { type FC, useRef } from "react";
import { type AriaButtonOptions, useButton } from "react-aria";

import { TodayIcon } from "@moment/icons";

import { type DatePickerProps } from ".";
import { makePointerStyles } from "../utilities";

export const CalendarIconButton: FC<
	Omit<AriaButtonOptions<"button">, "isDisabled"> & {
		size?: DatePickerProps["size"];
		disabled?: boolean;
		isPressed?: boolean;
	}
> = ({ isPressed = false, disabled = false, size = "sm", ...props }) => {
	props = Object.assign(props, { isDisabled: disabled });

	const ref = useRef<HTMLButtonElement>(null);
	const { buttonProps, isPressed: isPressedState } = useButton(props, ref);
	let iconSize = 16;
	if (size === "md") {
		iconSize = 20;
	} else if (size === "lg") {
		iconSize = 24;
	}

	return (
		<button
			{...buttonProps}
			ref={ref}
			className={cx(
				"px-2",
				"m-px",
				"outline-none",
				"bg-button-normal-secondary-default",
				makePointerStyles(disabled),
				{
					"bg-button-normal-secondary-active": isPressedState || isPressed,
					"rounded-r": size === "sm",
					"rounded-r-md": size === "md",
					"rounded-r-lg": size === "lg",

					"hover:bg-button-normal-secondary-hover": !disabled,
					"focus:bg-button-normal-secondary-focus": !disabled,
					"active:bg-button-normal-secondary-active": !disabled,

					"[&>svg]:fill-icon-default": !disabled,
					"[&>svg]:hover:fill-icon-hover": !disabled,
					"[&>svg]:active:fill-icon-active": !disabled,

					"[&>svg]:fill-icon-disabled": disabled,

					"px-2": size === "sm",
					"px-3": size === "md" || size === "lg",
				}
			)}
		>
			<TodayIcon size={iconSize} />
		</button>
	);
};
